<template>
        <div
            v-if="tableItems.length > 0"
            class="col-sm-12 list-content result-table"
        >
            <vue3-datatable
                ref="resultTable"
                :rows="tableItems"
                :columns="fields"
                :pagination="false"
                :sticky-header="true"
                :height="tableItems.length > 7 ? '52em' : '100%'"
                :sortable="true"
                skin="bh-table-compact"
                :row-class="getRowClass"
                cell-class="routa-table-cell"
                @row-click="emitEdit"
            >
                <template #created="row">
                    <span>{{ row.value.createdStr }}</span>
                </template>
                <template #completed="row">
                    <span>{{ row.value.completedStr }}</span>
                </template>
                <template #deadline="row">
                    <span>{{ row.value.deadlineStr }}</span>
                </template>
                <template #status="row">
                    <span>{{ row.value.status }} %</span>
                </template>

            </vue3-datatable>
        </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {dispatchHelper} from "@/components/mixins/DispatchMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: "DispatchList",
    mixins: [timeUtils, dispatchHelper],
    components: {Vue3Datatable},
    props: {
        items: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            fields: [
                {field: 'id', title: this.$t('api_keys.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'created', title: this.$t('delivery_note.date'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'deadline', title: this.$t('dispatch.deadline'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'completed', title: this.$t('dispatch.completed'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'createdBy', title: this.$t('dispatch.dispatcher'), sort: true, headerClass: 'routa-table-header'},
                {field: 'contract', title: this.$t('delivery_note.contract'), sort: true, headerClass: 'routa-table-header'},
                {field: 'order', title: this.$t('delivery_note.order'), sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('delivery_note.status'), sort: true, headerClass: 'routa-table-header'},
            ],
            tableItems: []
        }
    },
    watch: {
        notes: function () {
            this.initTableItems()
        }
    },
    mounted: function () {
        this.initTableItems()
    },
    methods: {
        getRowClass(row) {
            return 'routa-table-row'
        },

        initTableItems: function () {
            this.tableItems = []
            let temp = []
            this.items.forEach(item => {
                const status = this.getStatus(item)
                const completed = this.getCompletionTime(item)
                temp.push(
                    {
                        id: item.id,
                        created: item.created,
                        createdStr: this.toLocalTime(item.created),
                        deadline: item.deadline,
                        deadlineStr: this.toLocalTime(item.deadline),
                        completed: item.completed,
                        completedStr: completed ? this.toLocalTime(completed) : '',
                        contract: item.work_order.contract.name,
                        order: item.work_order.task_type.name,
                        createdBy: item.created_by.last_name + ', ' +item.created_by.first_name,
                        status: status,
                        _rowVariant: status === 100 ? 'success' : status === 0 ? 'danger' : 'warning'
                    }
                )
            })
            this.$nextTick(() => this.tableItems = temp)
        },
        emitEdit: function (note) {
            let item = this.items.find(item => item.id === note.id)
            if (item) {
                this.$emit('rowClick', item)
            }
        }
    }
}
</script>

